import type { BuiltInEdge, Edge, EdgeTypes } from '@xyflow/react';

export const initialEdges = [
  { 
    id: 'e1-2', 
    source: 'stage-1', 
    target: 'stage-2', 
    animated: true,
    markerEnd: { type: 'arrowclosed' }
  },
  { 
    id: 'e2-3', 
    source: 'stage-2', 
    target: 'stage-3', 
    animated: true,
    markerEnd: { type: 'arrowclosed' }
  },
  { 
    id: 'e3-4', 
    source: 'stage-3', 
    target: 'stage-4', 
    animated: true,
    markerEnd: { type: 'arrowclosed' }
  },
] satisfies Edge[];

export const edgeTypes = {
  // Add your custom edge types here!
} satisfies EdgeTypes;

// Append the types of your custom edges to the BuiltInEdge type
export type CustomEdgeType = BuiltInEdge;